import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Sidebar from './Sidebar';
import useGlobalContext from '../../hooks/useGlobalContext';

const Header = () => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { stickyMenu } = useGlobalContext();

    const scrollTo = (id) => {
        const element = document.getElementById(id);
        element.scrollIntoView({
            behavior: "smooth",
        });
    };

    return (
        <>
            <header id="home">
                <div className="header__area">
                    <div id="header__sticky" className={stickyMenu ? "sticky header__bottom header__bottom-2" : "header__bottom header__bottom-2"}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-xl-3 col-6">
                                    <div className="logo-3">
                                        <NavLink to="/">
                                            <img src="assets/img/logo.png" alt="Sjain" />
                                        </NavLink>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-3">
                                    <div className="header__bottom-right d-flex justify-content-center align-items-center">
                                        <div className="main-menu main-menu-3 menu_three_wrapper">
                                            <nav id="mobile-menu">
                                                <ul>
                                                    <li>
                                                        <Link to="/" onClick={() => scrollTo("home")}>Home</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/" onClick={() => scrollTo("features")}>Features</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/" onClick={() => scrollTo("clients")}>Our Clients</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/" onClick={() => scrollTo("contact")}>Contact Us</Link>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-3">
                                    <div className="header__bottom-right d-flex justify-content-end align-items-center">
                                        <div className="header__btn d-none d-sm-block d-xl-block">
                                            <Link to="/" className="z-btn z-btn-3" onClick={() => scrollTo("contact")}>
                                                Free Demo
                                            </Link>
                                        </div>
                                        <div onClick={handleShow} className="sidebar__menu d-lg-none">
                                            <div className="sidebar-toggle-btn sidebar-toggle-btn-3" id="sidebar-toggle">
                                                <span className="line"></span>
                                                <span className="line"></span>
                                                <span className="line"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header >

            <Sidebar show={show} handleClose={handleClose} />
        </>
    );
};

export default Header;